






import Vue from 'vue';

export interface DropdownOption {
  value: string;
}

export default Vue.extend({
  name: 'Dropdown',
  props: {
    value: {
      type: String,
      default: '',
    },
    isActive: Boolean,
  },
});
